import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useParticipanteSecaoConclusaoService() {
  const { authenticatedFetch } = useApi();
  const cleanPayload = (obj = {}) =>
    Object.fromEntries(
      Object.entries(obj).filter(([, v]) => v !== null && typeof v !== 'undefined' && v !== '')
    );

  const upsertParticipanteSecaoConclusao = async (dados) => {
    // dados esperados:
    // {
    //   idParticipanteTurma: string (hash),
    //   idSecao: string (hash),
    //   concluida?: boolean,
    //   dataConclusao?: string
    // }
    const response = await authenticatedFetch(URLS.CREATE_PARTICIPANTE_SECAO_CONCLUSAO, {
      method: 'POST',
      body: JSON.stringify(dados),
    });

    return response.json();
  };

  const marcarSecaoConcluida = async (dados) => {
    // dados esperados: { idParticipanteTurma: string, idSecao: string }
    const response = await authenticatedFetch(URLS.MARK_PARTICIPANTE_SECAO_CONCLUIDA, {
      method: 'POST',
      body: JSON.stringify(cleanPayload(dados)),
    });

    return response.json();
  };

  const marcarSecaoNaoConcluida = async (dados) => {
    // dados esperados: { idParticipanteTurma: string, idSecao: string }
    const response = await authenticatedFetch(URLS.MARK_PARTICIPANTE_SECAO_NAO_CONCLUIDA, {
      method: 'POST',
      body: JSON.stringify(cleanPayload(dados)),
    });

    return response.json();
  };

  const obterSecaoConclusaoPorId = async (id) => {
    const response = await authenticatedFetch(URLS.READ_PARTICIPANTE_SECAO_CONCLUSAO_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarSecaoConclusaoPorParticipanteTurma = async (idParticipanteTurma) => {
    const response = await authenticatedFetch(
      URLS.READ_PARTICIPANTE_SECAO_CONCLUSAO_BY_PARTICIPANTE_TURMA,
      {
        method: 'POST',
        body: JSON.stringify({ idParticipanteTurma }),
      }
    );

    return response.json();
  };

  const obterSecaoConclusaoPorParticipanteTurmaESecao = async (idParticipanteTurma, idSecao) => {
    const response = await authenticatedFetch(
      URLS.READ_PARTICIPANTE_SECAO_CONCLUSAO_BY_PARTICIPANTE_TURMA_AND_SECAO,
      {
        method: 'POST',
        body: JSON.stringify({ idParticipanteTurma, idSecao }),
      }
    );

    return response.json();
  };

  const listarSecoesConcluidasPorParticipanteTurmaEModulo = async (idParticipanteTurma, idModulo) => {
    const response = await authenticatedFetch(
      URLS.READ_PARTICIPANTE_SECOES_CONCLUIDAS_BY_PARTICIPANTE_TURMA_AND_MODULO,
      {
        method: 'POST',
        body: JSON.stringify(cleanPayload({ idParticipanteTurma, idModulo })),
      }
    );

    return response.json();
  };

  const deletarSecaoConclusaoPorId = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_PARTICIPANTE_SECAO_CONCLUSAO_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const deletarSecaoConclusaoPorParticipanteTurmaESecao = async (idParticipanteTurma, idSecao) => {
    const response = await authenticatedFetch(
      URLS.DELETE_PARTICIPANTE_SECAO_CONCLUSAO_BY_PARTICIPANTE_TURMA_AND_SECAO,
      {
        method: 'POST',
        body: JSON.stringify({ idParticipanteTurma, idSecao }),
      }
    );

    return response.json();
  };

  return {
    upsertParticipanteSecaoConclusao,
    marcarSecaoConcluida,
    marcarSecaoNaoConcluida,
    obterSecaoConclusaoPorId,
    listarSecaoConclusaoPorParticipanteTurma,
    obterSecaoConclusaoPorParticipanteTurmaESecao,
    listarSecoesConcluidasPorParticipanteTurmaEModulo,
    deletarSecaoConclusaoPorId,
    deletarSecaoConclusaoPorParticipanteTurmaESecao,
  };
}
